import BaseTrackingController from "../../../../../shared/src/ranj/equalture/platform/BaseTrackingController";
import InteractionEventName from "../data/InteractionEventName";

export default class TrackingController extends BaseTrackingController {

    constructor(dispatcher) {
        super(dispatcher);
    }


    /**
     * @param {ProgressValue} value 
     * @param {Number} elapsedTime in msecs
     */
    trackProgress(value, elapsedTime) {
        this._dispatchProgressEvent(value, elapsedTime);
    }

    /**
     * @param {Number} levelIndex Index of level, starting at 0
     * @param {Number} elapsedTime 
     */
    trackLevelStart(levelIndex, elapsedTime) {
        this._dispatchInteractionEvent(
            InteractionEventName.LEVEL_STARTED,
            { level: levelIndex },
            elapsedTime
        );
    }

    /**
     * @param {Number} levelIndex Index of level, starting at 0
     * @param {LevelEndType} endType Either LevelEndType.TIMEOUT or LevelEndType.USER
     * @param {Number} dragDistance 
     * @param {Number} elapsedTime 
     */
    trackLevelEnd(levelIndex, endType, dragDistance, elapsedTime) {
        this._dispatchInteractionEvent(
            InteractionEventName.LEVEL_ENDED,
            {
                level: levelIndex,
                end_type: endType,
                drag_distance: Math.round(dragDistance)
            },
            elapsedTime
        );
    }

    /**
     * @param {Number} levelIndex Index of level, starting at 0
     * @param {Bool} correct 
     * @param {Number} elapsedTime 
     */
    trackItemSelection(levelIndex, correct, elapsedTime) {
        this._dispatchInteractionEvent(
            InteractionEventName.ITEM_SELECTED,
            {
                level: levelIndex,
                correct: correct
            },
            elapsedTime
        );
    }
};
